import { render, staticRenderFns } from "./statisticalForms.vue?vue&type=template&id=df538b2a&scoped=true"
import script from "./statisticalForms.vue?vue&type=script&lang=js"
export * from "./statisticalForms.vue?vue&type=script&lang=js"
import style0 from "./statisticalForms.vue?vue&type=style&index=0&id=df538b2a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df538b2a",
  null
  
)

export default component.exports